import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@shopify/polaris/build/esm/styles.css";
import App from "./App";

// Wait for App Bridge to initialise before mounting React.
// This ensures window.shopify is available when components need idToken().
window.__shopifyAppReady.then(() => {
	const container = document.getElementById("root");
	if (!container) {
		throw new Error("Root element #root not found");
	}
	const root = createRoot(container);
	root.render(
		<React.StrictMode>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</React.StrictMode>,
	);
});
